import { apiClient, baseUrl } from './api.js';
import { unwrap } from './api-error.js';
import type { ApiPaths } from '@reos/api-client';

/**
 * Exporty reportu kancelare (krok T5, bod 3 auditu mockupu — polozka menu
 * „Reporty"). Endpoint je `GET /v1/dd-exports`
 * (`apps/api/src/routes/dd-exports.ts`); historii JEDNE zakazky ma vedle toho
 * `…/cases/:id/exports`, ktera se tady nepouziva.
 *
 * Typy chodi z vygenerovaneho OpenAPI klienta, ne z rucniho interface.
 */

export type DdExportItem =
  ApiPaths['/v1/dd-exports']['get']['responses']['200']['content']['application/json']['items'][number];

export async function listOfficeExports(limit?: number): Promise<DdExportItem[]> {
  const result = await unwrap(
    apiClient.GET('/v1/dd-exports', {
      params: { query: limit === undefined ? {} : { limit } },
    }),
  );
  return result.items;
}

/**
 * Krok UXF2 bod 1 (nalez #23, N2) — K ADRESE REPORTU STACI JEDEN DALSI DOTAZ.
 *
 * `dd_exports.case_id` je id AUDITNIHO pripadu (`dd_cases.id`), ktery adresu
 * nemovitosti uz nese (`addressQuery`) a drzi i odkaz na zakazku (`caseId`).
 * Seznam reportu si proto adresy dohleda z tehoz seznamu pripadu, ktery uz
 * API vraci — zadny novy endpoint ani join na serveru.
 */
export type DdCaseItem =
  ApiPaths['/v1/duediligence/cases']['get']['responses']['200']['content']['application/json']['items'][number];

export async function listAuditCases(limit = 200): Promise<DdCaseItem[]> {
  const result = await unwrap(apiClient.GET('/v1/duediligence/cases', { params: { query: { limit } } }));
  return result.items;
}

/** Absolutni adresa ke stazeni hotoveho PDF (soubor chodi mimo `apiClient`). */
export function exportDownloadUrl(downloadPath: string): string {
  return `${baseUrl}${downloadPath}`;
}
